const filteringColumns = [
	'NAME',
	'DESCRIPTION',
	'OWNER',
	'CREATEDAT',
	'MODIFIEDAT',
	'TAGS',
	'VERSION',
	'VERSIONDATE'
];

export default filteringColumns;
